import Grid from '@mui/material/Grid';

import { useMediaQuery, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import DetailsAccordion from './Components/Accordion';
import { getBankName } from '../../../../Axios/LimitManagement';

import { useNavigate, useParams } from 'react-router';
import Cash from './Components/TopupComponents/Cash';
import Cheque from './Components/TopupComponents/Cheque';
import CDM from './Components/TopupComponents/CDM';
import Online from './Components/TopupComponents/Online';
import UPI from './Components/TopupComponents/UPI';
import Neft_Rtgs from './Components/TopupComponents/Neft_Rtgs';
import Imps from './Components/TopupComponents/Imps';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import SubCard from 'ui-component/cards/SubCard';
import { IconCaretDownFilled } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import StatusTable from './Status';
import { getProfileDetails } from '../../../../Axios/Profile';


const Topup = () => {

  useEffect(()=>{
    getProfileDetails()
  },[])

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    };
  }
  // const [PostBankDetails, setPostBankDetails] = useState(null)

  const [BankDetails, setBankDetails] = useState(null);

  const Nav = useNavigate()

  const params = useParams();

  const [topuptype, setTopuptype] = useState(params.type);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const orientation = useMediaQuery('(min-width:600px)') ? 'horizontal':'horizontal'  ;
  const direction= useMediaQuery('(min-width:600px)') ? 'column':'column'

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleButtonClose = () => {
    setAnchorEl(null);
  };


  useEffect(() => {
    setTopuptype(params.type);
  }, [params.type]);
  console.log('type', topuptype);

  useEffect(() => {
    getBankName(setBankDetails);
  }, []);

  console.log('BankDetails', BankDetails);

  // const handleOptionChange = (event) => {
  //   setAge(event.target.value);
  // };

  // const handleBankChange = (index, setFieldValue) => {
  //   setFieldValue('bene_account', BankDetails[index].account_no)
  //   setFieldValue('bene', BankDetails[index].bank_name)
  //   setPostBankDetails(BankDetails[index])
  // }

  console.log(File);
  // console.log(PostBankDetails);
  const handleRoute = (url) => {
    Nav(url)
    handleButtonClose()
  }

  return (
    <div
      style={{
        height: '60vh',
        overflowY: 'scroll',
        scrollbarWidth: 'none'
      }}
    >
      <Typography variant='h4'>{topuptype}</Typography>
      <Grid container spacing={2}>
        <Grid item xl={12} lg={12} sm={12} xs={12}>
          <SubCard>
            <Grid container gap={3}>
              <Grid item xl={3} lg={4} sm={12} xs={12}>
                <Button
                  id="demo-positioned-button"
                  aria-controls={open ? 'demo-positioned-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                  variant='contained'
                  endIcon={<IconCaretDownFilled />}
                  color='primary'
                  fullWidth
                >
                  Topup Request
                </Button>
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleButtonClose}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  <MenuItem onClick={() => handleRoute('/limit/topup/Cash')}>Cash</MenuItem>
                  <MenuItem onClick={() => handleRoute('/limit/topup/CDM')}>CDM</MenuItem>
                  <MenuItem onClick={() => handleRoute('/limit/topup/Cheque')}>Cheque</MenuItem>
                  <MenuItem onClick={() => handleRoute('/limit/topup/Online Transfer')}>Online Transfer</MenuItem>
                  <MenuItem onClick={() => handleRoute('/limit/topup/NEFT-RTGS')}>NEFT / RTGS</MenuItem>
                  <MenuItem onClick={() => handleRoute('/limit/topup/UPI')}>UPI</MenuItem>
                  <MenuItem onClick={() => handleRoute('/limit/topup/IMPS')}>IMPS</MenuItem>


                </Menu>
              </Grid>

              <Grid item xl={3} lg={4} sm={12} xs={12}>
                <Button variant='contained' color='warning' onClick={()=>Nav('/limit/addmoney')} fullWidth>Add Money To Wallet</Button>
              </Grid>

              <Grid item xl={3} lg={4} sm={12} xs={12}>
                <Button variant='contained' color='error' fullWidth>VAN</Button>
              </Grid>
            </Grid>
          </SubCard>
        </Grid>

        <Box
      sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex',flexDirection:direction}}
    >
      <Tabs
        // sx={{}}
        orientation={orientation}
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider',visibility:topuptype?'visible':'hidden' }}
      >
        <Tab label={topuptype} sx={{visibility:topuptype?'visible':'hidden'}}  {...a11yProps(0)} />
        <Tab label="Transaction Data" sx={{visibility:topuptype?'visible':'hidden'}} {...a11yProps(1)} />

      </Tabs>
      <div>
      <TabPanel value={value} index={0}>
      {topuptype === 'Cash' ? (
          <Cash topupMode={'Cash'} />
        ) : topuptype === 'Cheque' ? (
          <Cheque topupMode={'Cheque'} />
        ) : topuptype === 'CDM' ? (
          <CDM topupMode={'CDM'} />
        ) : topuptype === 'Online Transfer' ? (
          <Online topupMode={'Online Transfer'} />
        ) : topuptype === 'NEFT-RTGS' ? (
          <Neft_Rtgs topupMode={'NEFT-RTGS'} />
        ) : topuptype === 'UPI' ? (
          <UPI topupMode={'UPI'} />
        ) : topuptype === 'IMPS' ? (
          <Imps topupMode={'IMPS'} />
        ) : null}
      </TabPanel>
      <TabPanel value={value} index={1}>
        <StatusTable/>
      </TabPanel>
     
      </div>
    </Box>
        
      </Grid>
      {
        !topuptype ? null : <DetailsAccordion rows={BankDetails} />

      }
    </div>
  );
};

export default Topup;
